import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saDataRetainabilityPer5QiCellChartConfig } from '../cellChartConfigs';

interface DataRetainabilityPer5QiSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataRetainabilityPer5QiSaCell: React.FC<DataRetainabilityPer5QiSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saDataRetainabilityPer5QiCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default DataRetainabilityPer5QiSaCell;
